import * as React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import Spinner from '../common/spinner';
import GenericInput from "../common/input/GenericInput";
import { Link } from "react-router-dom";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import SilentErrorBoundary from "../common/SilentErrorBoundary";
import { authContext } from "../../adalConfig";
import BrowserErrorDialog from './BrowserErrorDialog';

/**
 * Container component for the Login page.
 * 
 */
class Login extends React.Component {

    constructor(props) {
        super(props);
        const dBust = new Date();
        this.state = {
            fields: {
                username: '',
                password: ''
            },
            errors: {},
            userLoggedInOnLoad: false,
            loadBye: true,
            capsLock: false,
            showCapsLockWrn: false,
            bustKey: dBust.getTime()
        };
        //this.bClientSide = (typeof window !== "undefined");

        if (this.props && this.props.errorCode === 401) { //rendering happening twice so handle it in state.        
            let fields = this.state.fields;
            let errors = this.state.errors;
            errors["errorCode"] = this.props.errorCode;
            this.state = { fields: fields, errors: errors };
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUserNameChange = this.handleChange.bind(this, "username");
        this.handlePasswordChange = this.handleChange.bind(this, "password");
        this.setupMesssageClearTimer = this.setupMesssageClearTimer.bind(this);
        this.clearMessage = this.clearMessage.bind(this);
        this.handleKeyDownEvent = this.handleKeyDownEvent.bind(this);
        this.handleKeyUpEvent = this.handleKeyUpEvent.bind(this);
        this.handleLoginClick = this.handleLoginClick.bind(this);
        this.isMobile = Tools.isMobile();
    }

    //bClientSide = false;

    //componentWillMount() {
    //    this.setupMesssageClearTimer();
    //}

    componentDidMount() {
        this.setupMesssageClearTimer();
        if (!this.props.reDirectURL) {
            this.props.setRedirectUrl("/");
        }
        if (this.props.isLoggedIn && !this.state.userLoggedInOnLoad) {
            this.setState({ userLoggedInOnLoad: true })
        }
        const dBust = new Date();
        this.setState({ bustKey: dBust.getTime(), loadBye: true });
        logUI("UI.Login.ComponentDidMount", new Date(), Tools.getURLPath());
        if (document) {
            document.addEventListener("keydown", this.handleKeyDownEvent, false);
            document.addEventListener("keyup", this.handleKeyUpEvent, false);
            if (document.msCapsLockWarningOff === false) document.msCapsLockWarningOff = true;            
        }
    }
  
    componentDidUpdate() {
        this.setupMesssageClearTimer();
    }

    componentWillUnmount() {
        if (document) {
            document.removeEventListener("keydown", this.handleKeyDownEvent, false);
            document.removeEventListener("keyup", this.handleKeyUpEvent, false);
        }
    }

    timerHandle = null;


    clearMessage() {
        //debugger;
        //this.timerHandle = null;
        this.props.clearLogoutMessage();
        // logUI("clearMessage.clearLogoutMessage", new Date(), Tools.getURLPath());
    }

    setupMesssageClearTimer() {
        //debugger;
        if (this.timerHandle === null && typeof window !== "undefined") {
            this.timerHandle = window.setTimeout(this.clearMessage, 15000);
            //  logUI("setupMesssageClearTimer.ClearMessage", new Date(), Tools.getURLPath());
        }
    }

    setField(field, e) {
        let fields = this.state.fields;
        fields[field] = e;
        this.setState({ fields });
    }


    handleSubmit(event) {
        var oUser = authContext.getCachedUser();
        //debugger;
        var sTest = "KEFF";

        event.preventDefault();
        //this.props.loginError();
        let validationErrors = this.state.errors;
        validationErrors["errorCode"] = "";
        this.setState({ errors: validationErrors, loadBye: false });
        if (this.handleValidation()) {
            this.setField("submitted", true);
            //debugger;
            // We have to hack it like this to trigger IE to save the password.
            try {
                document.getElementById("LoginShim").contentDocument.getElementById("username").value = this.state.fields.username;
                document.getElementById("LoginShim").contentDocument.getElementById("password").value = this.state.fields.password;
                document.getElementById("LoginShim").contentDocument.getElementById("loginShim").submit();
            }
            catch (EE) {
                console.error(EE);
            }

            this.props.onLoginClick(this.state.fields.username, this.state.fields.password);
            logUI("Logon.Client.Post", new Date(), Tools.getURLPath());
            //this.setState({ fields: {} });
            //debugger;
            return true;
        }
        else {
            event.preventDefault();
            return false;
        }
    }

    handleChange(field, e) {
        let fields = this.state.fields;
        fields[field] = e.target.value;
        fields["submitted"] = false;
        this.setState({ fields });
        this.handleValidation();

    }

    handleValidation() {
        let fields = this.state.fields;
        let validationErrors = {};
        if (this.state.errors["errorCode"] === 401) {
            validationErrors["errorCode"] = "401";
        }
        let formIsValid = true;
        const errorUserName = "";
        const errorPassword = "";
        if (fields === undefined) {
            formIsValid = false;
            this.setState({ fields: { "username": "", "password": "" } });
            validationErrors["username"] = errorUserName;
            validationErrors["password"] = errorPassword;
        }
        else {
            //username
            if (!fields["username"]) {
                formIsValid = false;
                validationErrors["username"] = errorUserName;
            }
            //password
            if (!fields["password"]) {
                formIsValid = false;
                validationErrors["password"] = errorPassword;
            }
        }

        this.setState({ errors: validationErrors });
        return formIsValid;
    }

    handleKeyDownEvent(keyEvent) {
        this.handleCapsLockEvent(keyEvent);
    }

    //Added for support Mac 
    handleKeyUpEvent(keyEvent) {
        this.handleCapsLockEvent(keyEvent);
    }

    handleCapsLockEvent(keyEvent) {
        const { capsLock } = this.state;
        if (keyEvent.getModifierState && keyEvent.getModifierState('CapsLock') !== capsLock) {
            this.setState({ capsLock: keyEvent.getModifierState('CapsLock') });
        }
    }

    handleLoginClick(event) {
        event.preventDefault();
        authContext.login();
    }

    render() {

        var isClientSide = typeof window !== 'undefined';
        //console.log("Now rendering login... isClientSide: " + isClientSide);
        var oUser = authContext.getCachedUser();

        //debugger;
        var sUserName = (oUser && oUser.profile ? oUser.profile.name : "");
        const { reDirectURL, errorLogin, serviceError, verifiedLogin, reDirectParams, loginNotice } = this.props;
        const isUserLoggedin = this.props.isLoggedIn; // this.props.userDetails ? this.props.userDetails.access_token : false;
        const serviceWaitings = (this.props.waiting === false || this.props.waiting === undefined) ? false : true;
        const createAccountLink = this.props.myChartRegistrationUrl;
        const { isLoggedIn, myChartByeUrl, exchangingToken } = this.props;
        const { loadBye, bustKey, capsLock, showCapsLockWrn } = this.state;
        const bustedURL = myChartByeUrl + bustKey;
        const showInputs = false;

        const { userLoggedInOnLoad } = this.state;

        // Should not be solving this problem here
        if (userLoggedInOnLoad) { // && !errorLogin && !serviceError && this.state.fields.username && this.state.fields.submitted) {
            //debugger;
            if (isClientSide && window.location.pathname !== reDirectURL) {
                //debugger;
                //alert("redirecting to root");
                return <Redirect push to={reDirectParams ? reDirectURL + reDirectParams : reDirectURL || "/"} />;
            }
        }

        //if (isUserLoggedin && !errorLogin && !serviceError) {
        //    debugger;
        //    if (reDirectURL && reDirectURL !== null) {
        //        return <Redirect to={reDirectURL} />;
        //    } else {
        //        return <Redirect to='/' />;
        //    }
        //}

        return (
            <div className="container-fluid login-container">
                <div className="row video-hero__content">
                    {!serviceWaitings && !exchangingToken ?
                        <React.Fragment>
                            <div className="col-12 page-form-sm">
                                <div className="row login-logo">
                                    <div className="col-12">
                                        Community Support Admin
                                        {/*<img src="/images/bsw-virtual.svg" className="img-fluid" alt="Community Support Admin Logo" />*/}
                                    </div>
                                </div>
                                <div className="row login-heading">
                                    <h1><span className="icon-lock" /> BSWH Authorized Login</h1>
                                </div>

                                {(typeof loginNotice !== 'undefined' && loginNotice) &&
                                    <div className="col-12">
                                        <div className="row login-notice">
                                            <div className="col-1 icon">
                                                <span className="icon-error"/>
                                            </div>
                                            <div className="col-11">
                                                <p dangerouslySetInnerHTML={{
                                                    __html:  Tools.linkPhoneNumber(loginNotice) 
                                                }}/>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <form className="row login-form" onSubmit={this.handleLoginClick} >
                                    {((errorLogin || serviceError) || (this.state.errors["errorCode"] === 401)) ?
                                        <div className="col-12 form-errors">
                                            {(errorLogin || serviceError) &&
                                                <div>{errorLogin || "Login failed. Please try again later."}</div>
                                            }
                                            {(this.state.errors["errorCode"] === 401) &&
                                                <div>Your token has expired. Please sign in again.</div>
                                            }
                                        </div> : ""}
                                    {(this.props.logoutMessage) &&
                                        <div className={"col-12" + (this.props.logoutMessage === 'You have been logged out successfully.' ? " logout-msg" : " form-errors")}>
                                            <div>{this.props.logoutMessage}</div>
                                        </div>
                                    }
                                    {showInputs && <>
                                        <div className="col-12 form-group">
                                            <GenericInput
                                                placeholder="Username"
                                                autoFocus
                                                value={sUserName || this.state.fields["username"]}
                                                name="username"
                                                onChange={(e) => this.handleUserNameChange(e)}
                                                required ref="username"
                                                inputErrorMsg={this.state.errors["username"]}
                                                showClearBtn
                                            />
                                        </div>
                                        <div className="col-12 form-group">
                                            <GenericInput
                                                placeholder="Password"
                                                type="password"
                                                value={this.state.fields["password"]}
                                                name="password"
                                                ref="password"
                                                onChange={(e) => this.handlePasswordChange(e)}
                                                required
                                                inputErrorMsg={this.state.errors["password"]}
                                                onFocus={() => { if (!showCapsLockWrn) this.setState({ showCapsLockWrn: true }); }}
                                                onKeyUp={() => { if (!showCapsLockWrn) this.setState({ showCapsLockWrn: true }); }}
                                                onBlur={() => { if (showCapsLockWrn) this.setState({ showCapsLockWrn: false }); }}
                                                showClearBtn
                                                showEye
                                            />
                                        </div>
                                    </>}
                                    <div className="col-12 form-group">
                                        <input className="btn btn-provider-primary" type="submit" value="Sign In" disabled={!isClientSide} />
                                    </div>
                                {/*    <BrowserErrorDialog />*/}
                                </form>
                                <div className="row forgot-credentials">
                                    <div className="col-6 forgot-credentials__un">
                                        {(isClientSide && false) &&
                                            <Link to="/forgotusername" onClick={() => logUI("UI.Logon.ForgotUserNameClicked", new Date(), Tools.getURLPath())}>Forgot username?</Link>
                                        }
                                    </div>
                                    <div className="col-6 forgot-credentials__pw">
                                        {(isClientSide && false) &&
                                            <Link to="/forgotpassword" onClick={() => logUI("UI.Logon.ForgotPasswordClicked", new Date(), Tools.getURLPath())}>Forgot password?</Link>
                                        }
                                    </div>
                                </div>
                            </div>  
                            {false && 
                                <div className="col-12">
                                    <div className="row login-footer">
                                        <div className="col-12">
                                            <p>Need to set up an account? <a href={createAccountLink} className="create-account-link">Click here to get started</a></p>
                                            <p className="login-footer__links">
                                                <Link to={{ pathname: "/payasguest" }}><img className="login-footer__links--bill" src="/images/pay-bill.png" alt="Pay bill icon" aria-hidden="true" /> Pay a bill as a guest</Link>
                                                <a href="/faq#MyChart&MR_fam1"><img className="login-footer__links--family" src="/images/family-accounts.png" alt="Family account icon" aria-hidden="true" /> How to access family health</a>
                                            </p>
                                        </div>
                                    </div>
                                </div>                           
                            }
                        </React.Fragment>
                        : <Spinner />}
                </div>
                {/*<div className="video-hero__video">
                    <SilentErrorBoundary>
                        <video className="hero-video" autoPlay={!this.isMobile} loop muted>
                            <source src="/video/mybswh-bg.mp4" type="video/mp4" />
                            <source src="/video/mybswh-bg.webm" type="video/webm" />
                            <source src="/video/mybswh-bg.ogg" type="video/ogg" />
                            Sorry, but your browser doesn't support HTML5 video
                        </video>
                    </SilentErrorBoundary>
                </div>*/}
                {loadBye && verifiedLogin === true && !isUserLoggedin &&
                    <iframe title="loadBye" style={{ display: "none" }} src={bustedURL} />
                }
            </div>

        );
    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        userDetails: state.sso.userDetails,
        isError: state.sso.error,
        errorLogin: state.sso.loginError,
        waiting: state.sso.isFetching,
        reDirectURL: state.domain.ru,
        reDirectParams: state.domain.qp,
        errorCode: state.sso.error,
        myChartRegistrationUrl: state.session.serverData ? state.session.serverData.myChartRegistrationUrl : "",
        logoutMessage: state.domain.lom || null,
        isLoggedIn: state.domain.li || false,
        myChartByeUrl: state.session.serverData ? state.session.serverData.myChartByeUrl : "",
        verifiedLogin: state.sso.verifiedLogin,
        loginNotice: state.session.serverData ? state.session.serverData.loginNotice : "",
        exchangingToken: state.sso.exchangingToken
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLoginClick: (userId, password) => dispatch({ type: types.USER_AUTHENTICATE, userName: userId, password: password }),
        setRedirectUrl: (currentURL) => dispatch({
            type: types.SET_REDIRECT_URL, URL: currentURL
        }),
        logError: (error) => dispatch({ type: types.APPLICATION_ERROR, error: error }),
        loginError: () => dispatch({ type: types.USER_AUTHENTICATE_FAILURE }),
        clearLogoutMessage: () => {
            dispatch({ type: types.CLEAR_USERLOGGEDOUT_MESSAGE });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
